import { TextField } from "formik-material-ui";
import useSharedStyles from "../../../styles/Shared";
import { Field, Formik, Form as FormikForm } from "formik";
import { Box, FormControlLabel } from "@mui/material";
import CustomCheckbox from "../../../components/Form/CustomCheckbox";

type Props = {
  questionData?: ProjectSupplierQuestion | undefined;
  handleSubmit: (question: ProjectSupplierQuestion) => void;
  error: string | undefined;
};

const Form: React.FC<Props> = ({ questionData, handleSubmit, error }) => {
  const { classes } = useSharedStyles();

  const initialQuestion =
    questionData !== undefined
      ? questionData
      : {
        title: "",
        expected_answer: "",
        terminate_on_incorrect: false,
        number: 0,
        id: window.crypto.randomUUID(),
        deleted: false,
      };

  return (
    <Formik initialValues={initialQuestion} onSubmit={(values) => handleSubmit(values)}>
      {({ handleChange, values }) => (
        <FormikForm>
          <Box className={classes.fieldBox} sx={{ p: 0, mb: "0 !important" }}>
            <Field
              sx={{ mb: "5px" }}
              component={TextField}
              name="title"
              placeholder="Question to ask (eg. What colour is the sky?)"
              variant="outlined"
              value={values.title}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleChange(e);
                handleSubmit({ ...values, title: e.target.value });
              }}
              onBlur={() => {
                //handleSubmit(values);
              }}
              error={!!error}
              helperText={error}
              fullWidth
            />
            <Field
              component={TextField}
              name="expected_answer"
              placeholder="Expected answer (eg. Blue)"
              variant="outlined"
              value={values.expected_answer}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                handleChange(e);
                handleSubmit({ ...values, expected_answer: e.target.value });
              }}
              onBlur={() => {
                //handleSubmit(values);
              }}
              fullWidth
            />
            <FormControlLabel
              disabled={values.expected_answer === ""}
              label="Terminate respondent if answer is incorrect"
              name="terminate_on_incorrect"
              control={
                <CustomCheckbox
                  sx={{ py: 0 }}
                  color="secondary"
                  checked={values.terminate_on_incorrect || false}
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                    handleChange(e);
                    handleSubmit({ ...values, terminate_on_incorrect: e.target.checked });
                  }}
                />
              }
            />
          </Box>
        </FormikForm>
      )}
    </Formik>
  );
};

export default Form;
